import instance from 'utils/apiCalls';
import { TOOLTIP_URLS } from './tooltipUrls';
import { tooltipInterface } from '../../../types/interface';

export const getAllTooltipPages = () => async () => {
  const response = await instance.get(TOOLTIP_URLS.GET_ALL_TOOLTIP_PAGES);
  return response;
};

export const getAllTooltipInput = (param: string) => async () => {
  const response = await instance.get(
    `${TOOLTIP_URLS.GET_ALL_TOOLTIP_INPUTS}/${param}`
  );
  return response;
};

export const updateTooltipInput =
  (param: string, data: { tooltips: tooltipInterface[] }) => async () => {
    const response = await instance.put(
      `${TOOLTIP_URLS.UPDATE_TOOLTIP_INPUTS}/${param}`,
      data
    );
    return response;
  };
